import { jsx as _jsx } from "react/jsx-runtime";
const SvgStreamPlatformKick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icons",
		children: /* @__PURE__ */ _jsx("g", {
			id: "StreamingPlatform",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Platform=Kick",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Vector",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M4 2.5H13V8.5H16V5.5H19V2.5H28V11.5H25V14.5H22V17.5H25V20.5H28V29.5H19V26.5H16V23.5H13V29.5H4V2.5Z",
					fill: "#53FC18"
				})
			})
		})
	})
});
export default SvgStreamPlatformKick;
